/** The business line of the website application's details, when it has one ("Business: Pat's Electric"). */
export function businessFrom(notes?: string) {
  return notes?.split(/\r?\n/).map(l => l.match(/^\s*(?:business|business name|company)\s*:\s*(.+)$/i)?.[1]?.trim()).find(Boolean) ?? '';
}

/**
 * The referral picker on the one-screen review starts at the credit the application carries now (walkthrough rerun, 21
 * October 2026): the join link's SP Manager, a previous correction's, or the house book. Showing anything else invited a
 * press of "Correct the referral" that would move the credit by accident.
 */
export const creditPick = (credit: { staff_id: string | null } | null | undefined) => credit?.staff_id ?? 'house';
/** "Correct the referral" only acts once the approver picked someone other than the current credit. */
export const creditChanged = (picked: string, credit: { staff_id: string | null } | null | undefined) => picked !== creditPick(credit);
/** How long an application has waited, in plain words: "Waiting: under an hour", "Waiting: 5 hours", "Waiting: 3 days". */
export function waitingLabel(hours: number) {
  const h = Math.max(0, Math.floor(hours));
  return `Waiting: ${h < 1 ? 'under an hour' : h < 48 ? `${h} hour${h === 1 ? '' : 's'}` : `${Math.floor(h / 24)} days`}`;
}
